<template>
  <div>
    <b-nav-item-dropdown
      right
      toggle-class="d-flex align-items-center dropdown-user-link"
      class="dropdown-user"
      v-if="userData"
    >
      <template #button-content>
        <div class="d-sm-flex d-none user-nav">
          <p class="user-name font-weight-bolder mb-0">
            {{ userData.first_name | capitalize }}
          </p>
          <span class="user-status">{{ $t(userData.role) | capitalize }}</span>
        </div>
        <b-avatar
          size="40"
          :src="userData.image"
          variant="light-primary"
          badge
          class="badge-minimal"
          badge-variant="success"
        >
          <feather-icon v-if="!userData.fullName" icon="UserIcon" size="22" />
        </b-avatar>
      </template>

      <b-dropdown-item
        :to="{ name: 'pages-profile' }"
        link-class="d-flex align-items-center"
      >
        <feather-icon size="16" icon="UserIcon" class="mr-50" />
        <span v-t="'Profile'">Profile</span>
      </b-dropdown-item>

      <b-dropdown-item
        link-class="d-flex align-items-center"
        @click="showModalResetPassword"
      >
        <feather-icon size="16" icon="LockIcon" class="mr-50" />
        <span v-t="'Reset Password'">Change Password</span>
      </b-dropdown-item>
      <!-- <b-dropdown-item
      :to="{ name: 'apps-email' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="MailIcon" class="mr-50" />
      <span>Inbox</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'apps-todo' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
      <span>Task</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'apps-chat' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
      <span>Chat</span>
    </b-dropdown-item> -->

      <b-dropdown-divider />

      <!-- <b-dropdown-item
      :to="{ name: 'pages-account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="SettingsIcon" class="mr-50" />
      <span v-t="'Settings'"></span>
    </b-dropdown-item> -->
      <!-- <b-dropdown-item
      :to="{ name: 'pages-pricing' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="CreditCardIcon"
        class="mr-50"
      />
      <span>Pricing</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'pages-faq' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="HelpCircleIcon"
        class="mr-50"
      />
      <span>FAQ</span>
    </b-dropdown-item> -->
      <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
        <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
        <span v-t="'logout'"></span> </b-dropdown-item
    ></b-nav-item-dropdown>
    <ResetPasswordModal
      ref="reset-password-modal"
      v-if="showResetPassword"
      :user="userSelected"
      @close="closeResetPassword"
    />
  </div>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import { initialAbility } from "@/libs/acl/config";
import useJwt from "@/auth/jwt/useJwt";
import { avatarText } from "@core/utils/filter";
import ResetPasswordModal from "@/views/users/views/list/components/ResetPasswordModal.vue";
import { zergApi } from "@/service/zerg";
import { mapGetters } from "vuex";
export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    ResetPasswordModal,
  },
  computed: {
    ...mapGetters({
      user: "auth/dataUser",
    }),
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      avatarText,
      userSelected: {},
      showResetPassword: false,
    };
  },
  methods: {
    showModalResetPassword() {
      this.showResetPassword = true;
      this.userSelected = this.userData;
    },
    closeResetPassword() {
      this.showResetPassword = false;
    },
    async logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);

      // Remove userData from localStorage
      localStorage.removeItem("userData");

      const params = {
        user_id: this.user.id,
      };
      const data = await zergApi.post("/logout", params);

      // const request = indexedDB.open("zergdb");

      // request.onsuccess = (event) => {
      //   const db = event.target.result;
      //   // db.close();
      //   const deleteRequest = indexedDB.deleteDatabase("zergdb");
      //   deleteRequest.onsuccess = () => {
      //     console.log("Database deleted successfully");
      //   };

      //   deleteRequest.onerror = () => {
      //     console.error("Failed to delete database");
      //   };
      // };

      // request.onerror = (event) => {
      //   console.error("Failed to open database");
      // };

      // Reset ability
      this.$ability.update(initialAbility);

      // Redirect to login page
      this.$router.push({ name: "auth-login" });
    },
  },
};
</script>
